import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './Chip.styles'

const Chip = (props) => {
  const { category, onClose, tooltip, chipId, isLoading } = props

  const [visibility, setVisibility] = React.useState(true)

  const handleClick = () => {
    setVisibility(false)
    onClose(chipId)
  }

  return (
    <Component.Container>
      {visibility && (
        <Component.Button
          tab-index='0'
          role='filter'
          data-filter-value='on'
          data-filter-name={ category }
          onClick={ () => {
            !isLoading && handleClick()
          } }
          id={ chipId }
          isLoading={ isLoading }>
          {category}

          {tooltip && (
            <Component.TooltipWrapper>{tooltip}</Component.TooltipWrapper>
          )}
        </Component.Button>
      )}
    </Component.Container>
  )
}

Chip.defaultProps = {
  isLoading: false,
}

Chip.propTypes = {
  /** Text Content in Chip */
  category: PropTypes.string.isRequired,
  /** For Propagating Close Event Upwards */
  onClose: PropTypes.func.isRequired,
  /** Optional Tooltip for Chip */
  tooltip: PropTypes.node,
  /** Unique Identifier */
  chipId: PropTypes.string.isRequired,
  /** flag for loader */
  isLoading: PropTypes.bool,
}

export default Chip
